module.exports = __webpack_public_path__ + "static/media/stop_outer_ring.6c7f130f.svg";